import React from 'react';
import { SvgIcon } from '@mui/material';

const User = ({ ...props }) => (
    <SvgIcon {...props} width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
        <g id="Style-Guide" stroke="none" strokeWidth="1" fill="inherit" fillRule="evenodd">
            <g transform="translate(-432.000000, -2276.000000)" id="Icons">
                <g transform="translate(48.000000, 2212.000000)">
                    <g id="User-Icon" transform="translate(384.000000, 64.000000)">
                        <g id="1.-Icon/User">
                            <path
                                d="M11.778934,17.1711866 C14.3117705,16.4059639 17.0326255,16.4851249 19.5871185,16.9976414 C21.5135705,17.3853271 23,18.5808606 23,20.5162446 L23,20.5162446 L23,25.9205025 C22.9940937,25.9265918 22.9872029,25.9296364 22.9812966,25.9357257 C20.9495148,27.2357923 18.5613838,28 16,28 C13.4376318,28 11.0514696,27.2357923 9.01968781,25.9367406 C9.01279707,25.9306513 9.00590634,25.9265918 9,25.9205025 L9,25.9205025 L9,20.9435108 C9,19.1867464 10.1418928,17.6654351 11.778934,17.1711866 Z M10.4287442,10.7320513 C9.84598509,6.80444984 13.0797075,3.46954066 16.8912671,4.07035205 C19.2656167,4.44484429 21.2058501,6.44518087 21.5700745,8.89409622 C22.153818,12.8237275 18.9181268,16.1586367 15.1075517,15.5568104 C12.7332021,15.1813033 10.7919842,13.1799518 10.4287442,10.7320513 Z"
                                id="Combined-Shape"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);
export default User;
